@if (show){
<div class="ga-notification ga-notification--error toast-alert-gaia"
    role="alert"
    [ngClass]="alertErrorName === alertErrorNameConst.main ? 'toast-main': 'toast-dialog'">
    <span class="ga-notification__icon">
        <img src="assets/images/lucide/16_error.svg" width="24" height="24" aria-hidden="true" />
    </span>
    <div class="ga-notification__content">
        <div class="ga-notification__heading">
            <span class="ga-notification__title">Error</span>
            <div class="ga-notification__title-actions">
                <button type="button" class="close" (click)="close()" aria-label="Close">
                    <img src="assets/images/lucide/24_close.svg" width="20" height="20" aria-hidden="true" />
                </button>
            </div>
        </div>
        <div class="ga-notification__description" style="word-wrap: break-word;">
            @if(alertErrorMessage.errors.length === 0){
                <p>{{errorCode}}</p>
            } @else if (alertErrorMessage.errors.length < maximumMessagesDisplayedWithoutScroll) {
                @for (item of alertErrorMessage.errors; track $index) {
                    <p>
                        {{item.message}}
                        @if(item.status === 500 && item.guid && item.guid.length > 0) {
                            <span><br />{{errorCode}}: {{item.guid}}</span>
                        }
                    </p>
                }
            } @else {
                <div class="alert-msg-text scrollable">
                    @for (item of alertErrorMessage.errors; track $index) {
                        <p>
                            {{item.message}}
                            @if(item.status === 500 && item.guid && item.guid.length > 0) {
                                <span><br />{{errorCode}}: {{item.guid}}</span>
                            }
                        </p>
                    }
                </div>
            }
        </div>
    </div>
</div>
}
